import { render, staticRenderFns } from "./_tradeshowlist.vue?vue&type=template&id=5a60c745&scoped=true"
import script from "./_tradeshowlist.vue?vue&type=script&lang=js"
export * from "./_tradeshowlist.vue?vue&type=script&lang=js"
import style0 from "./_tradeshowlist.vue?vue&type=style&index=0&id=5a60c745&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a60c745",
  null
  
)

export default component.exports